var _defs, _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.563,
    height: 20.742,
    viewBox: "0 0 20.563 20.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4e4e4e;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.4,19.936a2.26,2.26,0,0,1,.183-2.525,2.26,2.26,0,0,1-.183-2.525l.73-1.263A2.261,2.261,0,0,1,13.084,12.5a2.3,2.3,0,0,1,.326.023,2.341,2.341,0,0,1,.1-.214A4.254,4.254,0,0,0,11.949,12H4.284A4.289,4.289,0,0,0,0,16.284V19.44a.677.677,0,0,0,.676.676h9.829Z",
    transform: "translate(0 -1.178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.868,17.932a3.277,3.277,0,0,0,.042-.423,3.427,3.427,0,0,0-.042-.423l.813-.615a.451.451,0,0,0,.118-.585l-.73-1.263a.451.451,0,0,0-.565-.19l-.935.394a3.351,3.351,0,0,0-.739-.439l-.124-.993A.452.452,0,0,0,18.258,13H16.8a.451.451,0,0,0-.447.395l-.124.993a3.365,3.365,0,0,0-.739.439l-.935-.394a.45.45,0,0,0-.565.19l-.73,1.263a.452.452,0,0,0,.118.585l.813.615a3.277,3.277,0,0,0-.042.423,3.428,3.428,0,0,0,.042.423l-.813.615a.451.451,0,0,0-.118.585l.73,1.263a.451.451,0,0,0,.565.19l.935-.395a3.35,3.35,0,0,0,.739.439l.124.993a.45.45,0,0,0,.446.395h1.458a.451.451,0,0,0,.447-.395l.124-.993a3.365,3.365,0,0,0,.739-.439l.935.394a.45.45,0,0,0,.565-.19l.73-1.263a.452.452,0,0,0-.118-.585Zm-3.339,1.381a1.8,1.8,0,1,1,1.8-1.8A1.8,1.8,0,0,1,17.529,19.313Z",
    transform: "translate(-1.296 -1.276)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.679cfeec5622de773bd11b91d99f1310.svg";
export { ForwardRef as ReactComponent };